module.exports = __webpack_public_path__ + "img/scratching.f767aecb.png";